/**
 * Returns the maximum selectable date based on futureYears setting (0 to 20).
 * If futureYears is 0, returns Dec 31 of current year.
 * If futureYears is N (e.g. 3), returns Dec 31 of (currentYear + N).
 * Default fallback is 3 years future if unspecified.
 */
export const getMaxDate = (futureYears?: number | boolean): Date => {
  const currentYear = new Date().getFullYear();
  if (futureYears === false) {
    return new Date();
  }
  const years = typeof futureYears === "number" ? futureYears : 3;
  return new Date(currentYear + years, 11, 31, 23, 59, 59, 999);
};
